export default class NodeDefinitionKrepre {
	/**
	 * @param {any} [krepre]
	 */
	constructor(krepre = null) {
		this.INSERT = krepre?.INSERT ?? { USE: true };
		this.LIST = krepre?.LIST ?? {};
		this.MODE = krepre?.MODE ?? 'NORMAL';
	}
}
